"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringBuilder = (function () {
    function StringBuilder(initialText) {
        this._parts = initialText ? [initialText] : [];
        this._value = {};
        this._len = 0;
    }
    StringBuilder.prototype.append = function (text) {
        this._parts[this._parts.length] = text;
        return this;
    };
    StringBuilder.prototype.appendLine = function (text) {
        this._parts[this._parts.length] = text ? text + '\r\n' : '\r\n';
        return this;
    };
    StringBuilder.prototype.clear = function () {
        this._parts = [];
        this._value = {};
        this._len = 0;
    };
    StringBuilder.prototype.isEmpty = function () {
        if (this._parts.length === 0)
            return true;
        return this.toString() === '';
    };
    StringBuilder.prototype.toString = function (separator) {
        separator = separator || '';
        var parts = this._parts;
        if (this._len !== parts.length) {
            this._value = {};
            this._len = parts.length;
        }
        var val = this._value;
        if (typeof (val[separator]) === 'undefined') {
            if (separator !== '') {
                for (var i = 0; i < parts.length;) {
                    if ((typeof (parts[i]) === 'undefined') || (parts[i] === '') || (parts[i] === null)) {
                        parts.splice(i, 1);
                    }
                    else {
                        i++;
                    }
                }
            }
            val[separator] = this._parts.join(separator);
        }
        return val[separator];
    };
    return StringBuilder;
}());
exports.StringBuilder = StringBuilder;
//# sourceMappingURL=string-builder.js.map


//////////////////
// WEBPACK FOOTER
// ../player-globalization/string-builder.js
// module id = 256
// module chunks = 0 1